// hooks/useFormOptions.js
import { useMemo } from 'react';
import dufyLogo from '../assets/dufy.png';
import tesifiveLogo from '../assets/tesifive.png';
import uniallyLogo from '../assets/unially.png'; 
import reyesLogo from '../assets/reyes.png';
import defaultLogo from '../assets/logo.png';

//FOTOS DE BANCOS
import logoNequi from '../assets/bancos/nequi.webp';
import logoBancolombia from '../assets/bancos/bancolombia.png';
import logoDaviplata from '../assets/bancos/daviplata.png';
import logopaypal from '../assets/bancos/paypal.png';

export function useFormOptions() {
  //lista de documentos
  const documentosList = useMemo(() => [
    'CEDULA DE CIUDADANIA',
    'CEDULA DE EXTRANJERIA',
    'PASAPORTE',
    'TARJETA DE IDENTIDAD',
  ], []);
  const documentosOptions = useMemo(() => 
    documentosList.map(doc => ({
      value: doc,
      label: doc
    }))
  , [documentosList]);

  //formacion academica lista
  const formacionAcademicaList = useMemo(() => [
    'BACHILLER',
    'ESTUDIANTE PREGRADO',
    'PREGRADO COMPLETO',
    'ESTUDIANTE POSGRADO',
    'POSGRADO COMPLETO',
  ], []);
  const formacionOptions = useMemo(() => 
    formacionAcademicaList.map(doc => ({
      value: doc,
      label: doc
    }))
  , [formacionAcademicaList]);

  //lista de servicios manejados
  const tipoServiciosList = useMemo(() => [
    '1. Realizacion de examenes / quices',
    '2. Realizacion de trabajos',
    '3. Realizacion de Tesis',
    '4. Realizacion de clases virtuales'
  ], []);
  const tipoServicioOptions = useMemo(() => 
    tipoServiciosList.map(doc => ({
      value: doc,
      label: doc
    }))
  , [formacionAcademicaList]);

  //lista de cuentas bancarias
  const modalidadList = useMemo(() => [
    'VINCULADO A EMPRESA',
    'INDEPENDIENTE',
  ], []);
  const modalidadListOptions = useMemo(() => 
    tipoServiciosList.map(doc => ({
      value: doc,
      label: doc
    }))
  , [formacionAcademicaList]);

  //lista de cuentas bancarias
  const cuentasBancariasList = useMemo(() => [
    'NEQUI',
    'BANCOLOMBIA',
    'PAYPAL',
    'DAVIPLATA',
    'BINANCE',
    'RAPPI',
    'EFECTIVO',
    'LLAVE',
  ], []);
  const cuentasBancariasListOptions = useMemo(() => 
    cuentasBancariasList.map(doc => ({
      value: doc,
      label: doc
    }))
  , [formacionAcademicaList]);

  //lista de experiencias laborales
  const modalidadexperiencialaboralList = useMemo(() => [
    'VINCULADO A EMPRESA',
    'INDEPENDIENTE'
  ], []);

  //tipos de servicios
  const tipoServiciosListAdmin = useMemo(() => [
    'PARCIAL',
    'TALLER',
    'QUIZ',
    'CLASES PERSONALIZADAS',
    'TESIS'
  ], []);
  const tipoServiciosOptions = useMemo(() => 
    tipoServiciosListAdmin.map(doc => ({
      value: doc,
      label: doc
    }))
  , [documentosList]);

  //nombres de empresas
  const empresasList = useMemo(() => [
    'DUFY ASESORIAS',
    'TESIFY', 
    'REYES_ASESORIAS',
    'UNIALLY'
  ], []);

  //Tipos de Estados de solicitud
  const estadoSolicitudVisibles = useMemo(() => [
    'DISPONIBLE',
    'EXPIRADO',
    'ESPERANDO',
    'NO PODEMOS',
    'A PAGAR',
  ], []);

  //listas para obtener logo por empresa
  const logosEmpresas = {
    'DUFY ASESORIAS': dufyLogo,
    'TESIFY': tesifiveLogo,
    'UNIALLY': uniallyLogo,
    'REYES_ASESORIAS': reyesLogo,
    // Puedes añadir un logo por defecto
    'DEFAULT': defaultLogo
  };

  const obtenerLogoEmpresa = (nombreEmpresa) => {

    return logosEmpresas[nombreEmpresa] || logosEmpresas['DEFAULT'];
    
    };
    
  //obtener lista de procedencia
  const procedenciaUsuarioList = useMemo(() => [
    'FACEBOOK',
    'WHATSAPP',
    'REFERIDO AMIGO',
    'INSTAGRAM',
    'CAMPAÑA INSTAGRAM'
  ], []);
  const procedenciaUsuarioListOptions = useMemo(() => 
    procedenciaUsuarioList.map(doc => ({
      value: doc,
      label: doc
    }))
  , [procedenciaUsuarioList]);

  //MATERIAS PARA TESIS
  const materiasTesisList = useMemo(() => [
    'ANTEPROYECTO',
    'TESIS',
    'PRUEBAS',
    'ARTICULOS CIENTIFICOS',
    'CORRECIONES',
  ], []);
  const materiasTesisListOptions = useMemo(() => 
    materiasTesisList.map(doc => ({
      value: doc,
      label: doc
    }))
  , [materiasTesisList]);

  //TIPOS DE PAGOS
  const tipoReferenciasPagos = useMemo(() =>[
    'CLIENTES',
    'TUTOR',
    'REEMBOLSOCLIENTE',
    'REEMBOLSOTUTOR',
    'REFERIDOS',
  ], []);
  const tipoReferenciasPagosOptions = useMemo(() => 
    tipoReferenciasPagos.map(doc => ({
      value: doc,
      label: doc
    }))
  , [tipoReferenciasPagos]);

  //TIPOS DE EVENTOS PARA SERVICIOS tipoEventosParciales
  const tipoEventosParciales = useMemo(() =>[
    'AVANCE',
    'CORRECION',
    'ADICIONAL',
    'REVISION',
  ], []);
  const tipoEventosParcialesOptions = useMemo(() => 
    tipoEventosParciales.map(doc => ({
      value: doc,
      label: doc
    }))
  , [tipoEventosParciales]);

  //EVENTOS DE PROUNAD
  const eventosProUNAD = useMemo(() =>[
    'COTIZANDO',
    'COTIZACION_PASADA',
    'CONTACTO_CLIENTE',
    'NO_ACCESO_PLATAFORMA',
    'COTIZACION_LISTA',
    'TRABAJANDO',
    'NO_APROBADO',
  ], []);
  const eventosProUNADOptions = useMemo(() => 
    eventosProUNAD.map(doc => ({
      value: doc,
      label: doc
    }))
  , [eventosProUNAD]);

  //LISTA DE TAGS
  const whatsappTags = useMemo(() => [
    'NUEVO',
    'COTIZANDO',
    'A PAGAR',
    'PAGADO',
  ], [])
  const whatsappTagsOptions = useMemo(() => 
    whatsappTags.map(doc => ({
      value: doc,
      label: doc
    }))
  , [whatsappTags]);

  //EVENTOS PROUNAD TRABAJANDO
  //FASE ENTREGADA
  //SIGUIENTE FASE

  //PROCESOS DE REVISION
  const conceptoRevision = useMemo(() => [
    'PERDIDO',
    'PREGUNTA',
    'CORRECION',
  ], [])
  const conceptoRevisionOptions = useMemo(() => 
    conceptoRevision.map(doc => ({
      value: doc,
      label: doc
    }))
  , [conceptoRevision]);

  //URLS DE SISTEMA
  const URLS_SISTEMA = {
    ADMIN: "https://sistemademo.dufyasesorias.com",
    CLIENTE: "https://portalcliente.dufyasesorias.com",
    TUTOR: "https://tutor.dufyasesorias.com"
  };

  return {
    documentosOptions,
    formacionOptions,
    tipoServiciosList,
    modalidadexperiencialaboralList,
    cuentasBancariasListOptions,
    tipoServiciosListAdmin,
    tipoServiciosOptions,
    obtenerLogoEmpresa,
    estadoSolicitudVisibles,
    empresasList,
    procedenciaUsuarioListOptions,
    tipoReferenciasPagosOptions,
    materiasTesisListOptions,
    tipoEventosParcialesOptions,
    eventosProUNADOptions,

    //CONCEPTO REVISIONES
    conceptoRevision,
    conceptoRevisionOptions,

    //URL
    URLS_SISTEMA,
  };
}

export function useLogosBancos() {

  //DICCIONARIO DE BANCOS
  const bancos_logos = {
    'WOMPI' : dufyLogo,
    'NEQUI': logoNequi,
    'BANCOLOMBIA': logoBancolombia,
    'PAYPAL': logopaypal,
    'DAVIPLATA': logoDaviplata, 
    'BINANCE': dufyLogo, 
    'RAPPI': dufyLogo, 
    'EFECTIVO': dufyLogo, 
    'LLAVE': dufyLogo, 
    'default': dufyLogo
  }
  const getBancoLogo = (nombreBanco) => {
    console.log("nombre de banco",nombreBanco);
    if (!nombreBanco) return bancos_logos['default'];
    
    // Convertimos a minúsculas para comparar fácil
    const key = nombreBanco;
    
    // Retornamos el logo si existe, o el default si no
    return bancos_logos[key] || bancos_logos['default'];
  };

  return {
    getBancoLogo,
  };

}

export const dufyAdmon = true;
export const isClientes = true;
//produccion o pruebas
export const isProduction = true;

//SISTEMA DUFY Y TUTORES
//dufy admon = true
//is clientes = false

//SISTEMA CLIENTES
//dufy admon = true
//is cliente s= true

//SISTEMA EDUSMART
//dufy admon = false
//is clientes = false